var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23,
    fill: "#FF8328",
    stroke: "white",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0909,
    cy: 24.0909,
    r: 13.0909,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6685 22.8428H24.7882V25.642H23.6685V22.8428ZM23.668 26.2019H24.7877V27.3216H23.668V26.2019Z",
    fill: "#FF8328"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2192 19.5946C25.0244 19.2279 24.6448 19 24.2294 19C23.814 19 23.4344 19.2279 23.2396 19.5951L19.1314 27.3563C19.0403 27.5267 18.9951 27.718 19.0004 27.9112C19.0057 28.1044 19.0613 28.2929 19.1617 28.4581C19.2606 28.624 19.4011 28.7612 19.5693 28.8563C19.7374 28.9513 19.9275 29.0009 20.1207 29H28.3381C28.7345 29 29.0934 28.7973 29.2977 28.4581C29.3979 28.2928 29.4534 28.1043 29.4587 27.9112C29.464 27.718 29.4189 27.5268 29.3279 27.3563L25.2192 19.5946ZM20.1207 27.8803L24.2294 20.1191L28.3409 27.8803H20.1207Z",
    fill: "#FF8328"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.fef656ce6568ed442c29f9dc91c68d03.svg";
export { ForwardRef as ReactComponent };